import React from 'react';
import { ShowSetting } from './ShowSliderSetting';
import { analogOverwritePercent, analogOverwriteRaw } from '../Utils/analog_overwrite';

// Keep drafts, reset baselines and payloads in protocol units. Only the widget
// works in percent, so its +/- buttons also move by one percentage point.
export default function AnalogOverwriteSetting({
  cur_value,
  controller_value,
  controls,
  ...props
}) {
  return (
    <ShowSetting
      {...props}
      cur_value={analogOverwritePercent(cur_value)}
      controller_value={analogOverwritePercent(controller_value)}
      min={0}
      max={100}
      unit=" %"
      controls={{
        ...controls,
        setValue: (id, percent, ...args) =>
          controls.setValue(id, analogOverwriteRaw(percent), ...args),
        ...(controls.onChangeCommitted && {
          onChangeCommitted: (id, percent, ...args) =>
            controls.onChangeCommitted(id, analogOverwriteRaw(percent), ...args)
        })
      }}
    />
  );
}
